// extracted by mini-css-extract-plugin
export var banner = "_fa-0";
export var closeButton = "_fa-2";
export var greenCheckmark = "_fa-3";
export var hereLink = "_fa-4";
export var titleIcon = "_fa-1";